/**
 * 用户信息相关API
 */
import http from './http.js';
import util from '../store/utils';

export default class UserAPI {
    //用户登录
    static login(data) {
        return http.httpPost('user/login', data);
    }

    //用户注册
    static register(data) {
        return http.httpPost('user/register', data);
    }

    static getToken(phone, password) {
        return new Promise((resolve, reject) => {
            return http.httpSend({
                method: 'post',
                url: '/oauth2/token',
                data: `client_id=webchecker&grant_type=password&username=${phone}&password=${password}&response_type=code&state=default`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }

            }).then((res) => {
                let authorization = 'Bearer ' + res.accessToken;
                util.runAuth('set', authorization, 12, 'h');
                window.localStorage.user = JSON.stringify(res.user);
                resolve(res.user);
            }, (err) => {
                // return err;
                reject(err);
            });
        });
    }

    static save(data) {
        return http.httpPost('user', data);
    }

    static resetPassword(data) {
        return http.httpPost('user/resetpassword', data);
    }

    static getUser(userId) {
        return http.httpGet('user', {
            id: userId
        });
    }

    static hasUserWhite(phone) {
        return http.httpGet('user/hasuserwhite', {phone});
    }

    static isUserCheck(userId) {
        return http.httpGet('check/isUserCheck', {userId});
    }

    static cancelCheck(userId) {
        return http.httpPost('check/cancel', {userId});
    }

    // 在线反馈
    static postFeedback(params) {
        return http.httpPost('user/feedback', params);
    }
}



// WEBPACK FOOTER //
// ./app/api/user.api.js